const router = function (permissions) {
  return ({
    path: 'cdc/plano-pagamento',
    component: () => import('@/views/PlanoPagamento/PlanoPagamentoModule.vue'),
    meta: { permissions },
    children: [
      {
        path: '/',
        component: () => import('@/views/PlanoPagamento/PlanoPagamentoList.vue'),
        meta: { permissions, title: 'Manutenção de Planos de Pagamento' },
      },
      {
        path: 'cadastrar',
        component: () => import('@/views/PlanoPagamento/PlanoPagamentoProfile.vue'),
        meta: { permissions, title: 'Cadastrando Plano de Pagamento' },
      },
      {
        path: 'alterar',
        component: () => import('@/views/PlanoPagamento/PlanoPagamentoProfile.vue'),
        meta: { permissions, title: 'Editando Plano de Pagamento' },
      },
    ],
  })
}

export default {
  router,
}
